<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="18" height="18" rx="4" fill="currentColor" opacity="0.1" />
    <path
      d="M8 7C7.44772 7 7 7.44772 7 8V16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V14H13C15.2091 14 17 12.2091 17 10C17 7.79086 15.2091 6 13 6H8C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8H13C14.1046 8 15 8.89543 15 10C15 11.1046 14.1046 12 13 12H9V8C9 7.44772 8.55228 7 8 7Z"
      fill="currentColor"
    />
  </svg>
</template>
